@if (cardDetail()) {
  <app-view-cards
    [cardDetail]="cardDetail()"
    [cardBalance]="cardBalance()"
    title="Subscription card details">
    <ng-container heading>
      <div class="col-auto">
        <app-avatar
          [firstName]="cardDetail().name"
          [size]="'lg'"></app-avatar>
      </div>
      <div class="col">
        <div class="text-muted mb-1">Card name:</div>
        <div class="h3">{{ cardDetail().name }}</div>
      </div>
    </ng-container>

    <ng-container cardholderDetails>
      @if (cardDetail().holder; as holder) {
        <div class="row">
          <div class="col-4">
            <div class="text-muted">First name:</div>
            <div class="h4">{{ holder.first_name }}</div>
          </div>
          <div class="col-4">
            <div class="text-muted">Last name:</div>
            <div class="h4">{{ holder.last_name }}</div>
          </div>
        </div>
      }
    </ng-container>
  </app-view-cards>
} @else {
  <app-loader class="my-4"></app-loader>
}
